/** Vul desgewenst via VITE_LEGAL_* om te overrulen (bijv. staging). */
export const LEGAL_ORG_NAME = import.meta.env.VITE_LEGAL_ORG_NAME ?? 'Flexconsult24';
export const LEGAL_CONTACT_EMAIL =
  import.meta.env.VITE_LEGAL_CONTACT_EMAIL ?? 'info@ComfortTool.nl';
